import PropTypes from "prop-types";
import React from "react";
import "./Heading.css";

const Heading = (props) => {
	const {
		type,
		uppercase,
		color,
		children,
		weight,
		style = {},
		size,
		className
	} = props;

	const classNameDef = `Heading
	Heading-color__${color}
	fontSize_${size}
	fontWeight_${weight}
	${uppercase ? "Heading__uppercase" : ""}
	${className}
	`;

	switch (type) {
		case 1: {
			return (
				<h1 className={classNameDef} style={style}>
					{children}
				</h1>
			);
		}
		case 2: {
			return (
				<h2 className={classNameDef} style={style}>
					{children}
				</h2>
			);
		}
		case 3: {
			return (
				<h3 className={classNameDef} style={style}>
					{children}
				</h3>
			);
		}
		case 4: {
			return (
				<h4 className={classNameDef} style={style}>
					{children}
				</h4>
			);
		}
		default: {
			return (
				<h2 className={classNameDef} {...style}>
					{children}
				</h2>
			);
		}
	}
};

Heading.propTypes = {
	type: PropTypes.oneOf([1, 2, 3, 4]),
	uppercase: PropTypes.bool,
	color: PropTypes.oneOf([
		"dark",
		"link",
		"yellow",
		"red",
		"blue",
		"green",
		"light"
	]),
	weight: PropTypes.oneOf([900, 800, 700, 600, 500, 400, 300, 200, 100]),
	size: PropTypes.oneOf([14, 16, 18, 20, 24, 32, 48]),
	className: PropTypes.string
};

Heading.defaultProps = {
	type: 2,
	uppercase: false,
	color: "dark",
	weight: 600,
	size: 24,
	className: ""
};

export default Heading;
